import { render, staticRenderFns } from "./LsportDetail.vue?vue&type=template&id=2acba98d&scoped=true"
import script from "./LsportDetail.vue?vue&type=script&lang=js"
export * from "./LsportDetail.vue?vue&type=script&lang=js"
import style0 from "./LsportDetail.vue?vue&type=style&index=0&id=2acba98d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acba98d",
  null
  
)

export default component.exports